import axios from 'axios'

const getBaseUrl = () => {
  const baseUrl = process.env.VUE_APP_LOQATE_BASE_URI
  if (!baseUrl) {
    throw new Error(
      'The VUE_APP_LOQATE_BASE_URI environment variable is required, but was not specified'
    )
  }
  return baseUrl
}

export const get = (query, type) => {
  query = encodeURI(query)
  type = encodeURI(type)
  return axios
    .get(`${getBaseUrl()}?q=${query}&type=${type}&appname=insurance`)
    .then(response => {
      return response
    })
    .catch(error => {
      return error
    })
}
